import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-timetable-time-clash',
  templateUrl: './timetable-time-clash.component.html',
  styleUrls: ['./timetable-time-clash.component.css']
})
export class TimetableTimeClashComponent implements OnInit {

  @Input() fullMessageHTMLString: string;
  @Input() showTimeSlot: string;
  @Input() showClass: string;
  @Input() staffImage: string;
  @Input() visible: string;
  @Output() save_button_event: EventEmitter<any> = new EventEmitter();
  @Output() closePopup: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  removeTimeSlot(){
    this.visible = 'none';
    this.save_button_event.emit();
  }

  cancel(){
    this.visible = 'none';
    this.closePopup.emit();
  }

}
